import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../api.js'
import { useAuth } from '../auth/AuthContext.jsx'

// Admin: course categories list. Create/rename happen on their own form
// page (/admin/categories/new, /admin/categories/:id/edit) — no modals.
// Categories are never deleted (courses reference them).

export function AdminCategoriesPage() {
  const { t } = useTranslation()
  const { user, loading: authLoading } = useAuth()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (authLoading || !user || user.role !== 'admin') return
    api.admin.categories.list()
      .then((d) => setRows(d.categories || []))
      .catch((e) => setError(e.code || 'server'))
      .finally(() => setLoading(false))
  }, [authLoading, user])

  if (authLoading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!user || user.role !== 'admin') {
    return <main className="container"><p className="error">{t('admin.errors.not_admin')}</p></main>
  }

  return (
    <main className="container">
      <p><Link to="/admin">← {t('admin.title')}</Link></p>
      <h1>{t('admin_categories.title')}</h1>
      <p className="muted">{t('admin_categories.intro')}</p>
      <p><Link to="/admin/categories/new"><button type="button">{t('admin_categories.add')}</button></Link></p>

      {error && <p className="error">{t(`admin_categories.errors.${error}`, { defaultValue: error })}</p>}
      {loading && <p>{t('common.loading')}</p>}
      {!loading && rows.length === 0 && <p className="muted">{t('admin_categories.empty_state')}</p>}

      {!loading && rows.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>{t('admin_categories.col_name')}</th>
              <th>{t('admin_categories.col_courses')}</th>
              <th>{t('admin_categories.col_actions')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>{c.course_count}</td>
                <td><Link to={`/admin/categories/${c.id}/edit`}>{t('common.edit')}</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  )
}
